export const SuccessSummary = ({ form, certificate }) => {
  return (
    <div className="max-w-4xl mx-auto py-8 space-y-6">
      {/* HEADER */}
      <div className="text-center">
        <h3 className="text-xl font-bold text-emerald-600">
          Warranty Activated Successfully 🎉
        </h3>
        <p className="text-sm text-slate-600 mt-2">
          Warranty certificate has been generated for the device.
        </p>
      </div>

      {/* CERTIFICATE INFO */}
      {/* <div className="rounded-2xl border bg-white shadow-sm p-6 flex justify-center"> */}
        <div className="flex flex-col items-center gap-3 text-center">
          <div>
            <p className="text-xs text-slate-500">Certificate ID</p>
            <p className="text-sm font-semibold text-slate-900">
              {certificate?.certificateId || "-"}
            </p>
          </div>

          <a
            href={certificate?.certificateUrl}
            download
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex w-fit items-center justify-center px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700"
          >
            Download Certificate
          </a>
        </div>
      </div>

     
    // </div>
  );
};

